import React from "react";
import GoBackButton from "../../components/GoBackButton";
import Header from "../../components/Header";

export default props => {
    return (
        <div>
            <Header/>

            <section className="text-based">
        <div className="row">
          <div>
            <GoBackButton/>
            <h3>Disclaimer for Solyd Floors, LLC</h3>
            <h5>
              If you require any more information or have any questions about our site’s disclaimer, please 
              feel free to contact us by email at admin@solydfloors.com. Our Disclaimer was generated with 
              the help of the Disclaimer Generator. <br /><br />
              Disclaimers for Solyd Floors
              All the information on this website - http://www.solydfloors.com - is published in good faith 
              and for general information purpose only. Solyd Floors does not make any warranties about 
              the completeness, reliability and accuracy of this information. Any action you take upon the 
              information you find on this website (Solyd Floors), is strictly at your own risk. Solyd Floors will 
              not be liable for any losses and/or damages in connection with the use of our website.
              From our website, you can visit other websites by following hyperlinks to such external sites. 
              While we strive to provide only quality links to useful and ethical websites, we have no control 
              over the content and nature of these sites. These links to other websites do not imply a 
              recommendation for all the content found on these sites. Site owners and content may change 
              without notice and may occur before we have the opportunity to remove a link which may 
              have gone ‘bad’. <br /><br />
              Please be also aware that when you leave our website, other sites may have different privacy 
              policies and terms which are beyond our control. Please be sure to check the Privacy Policies 
              of these sites as well as their “Terms of Service” before engaging in any business or uploading 
              any information. Our Privacy Policy was created by the Privacy Policy Generator.
              Consent <br /><br />
              By using our website, you hereby consent to our disclaimer and agree to its terms. <br /><br />
              Update
              Should we update, amend or make any changes to this document, those changes will be 
              prominently posted here.
            </h5>
          </div>
        </div>
      </section>

        </div>
    )
}